
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { RetentionPolicyFormValues } from '../schemas/retentionPolicySchema';

interface StateFieldProps {
  form: UseFormReturn<RetentionPolicyFormValues>;
}

export function StateField({ form }: StateFieldProps) {
  return (
    <FormField
      control={form.control}
      name="state"
      render={({ field }) => (
        <FormItem>
          <FormLabel>State (Optional)</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value || "all"}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="All States" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="all">All States</SelectItem>
              <SelectItem value="FL">Florida</SelectItem>
              <SelectItem value="CA">California</SelectItem>
              <SelectItem value="TX">Texas</SelectItem>
              <SelectItem value="NY">New York</SelectItem>
            </SelectContent>
          </Select>
          <FormDescription>
            If specified, policy will only apply to records for this state
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
